import { useAnalyticsTracking, useEmitUiEvent } from '@montugroup/data-collection';
import { useCallback } from 'react';

export const usePrescriptionsTracking = () => {
  const emitEvent = useEmitUiEvent();
  const { uiEvent } = useAnalyticsTracking();
  const contextId = uiEvent?.context_id;

  const trackDownloadTreatmentLetter = useCallback(
    (prescriptionCode: string) => {
      emitEvent({
        component_name: 'DownloadScriptEvidenceButton',
        event_name: 'download_script_evidence',
        id: 'download_script_evidence',
        value: prescriptionCode,
        context_id: contextId,
      });
    },
    [emitEvent, contextId],
  );

  return {
    trackDownloadTreatmentLetter,
  };
};
